export default __webpack_public_path__ + "static/presence-dark-121b4897178f8210412ee037c226f1bd.png";